// frontend/src/components/wizard/StepReview/DangerZone.jsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useLanguageStore } from '../../../store/useLanguageStore';

export const DangerZone = ({ editId, pipelineStatus, handleAnnulClick, handleReactivate }) => {
  const { t } = useLanguageStore();
  if (!editId) return null;

  return (
    <div className="mt-6 border border-red-200 bg-red-50/80 p-5 rounded-2xl shadow-sm flex flex-col sm:flex-row items-center justify-between gap-4 animate-in fade-in">
      <h4 className="text-red-800 font-bold flex items-center m-0">
        <AlertCircle className="w-5 h-5 mr-2" /> {t('wizard.review.danger_zone.title') || 'Zona de Peligro'}
      </h4>
      {pipelineStatus !== 0 ? (
        <button
          type="button"
          onClick={handleAnnulClick}
          className="bg-white border border-red-200 text-red-600 font-bold px-6 py-2 rounded-xl text-sm hover:bg-red-50 hover:border-red-300 transition-all shadow-sm w-full sm:w-auto"
        >
          {t('wizard.review.danger_zone.annul') || 'Anular Configuración'}
        </button>
      ) : (
        <button
          type="button"
          onClick={handleReactivate}
          className="bg-emerald-600 text-white font-bold px-6 py-2 rounded-xl text-sm hover:bg-emerald-700 transition-all shadow-sm w-full sm:w-auto"
        >
          {t('wizard.review.danger_zone.reactivate') || 'Reactivar Configuración'}
        </button>
      )}
    </div>
  );
};